var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.length)?_c('div',[_c('h5',{staticClass:"page-title mb-4"},[_vm._v(" Continue assistindo ")]),_c('home-carousel',{attrs:{"list":_vm.data,"per-page-custom":[
      [576, 2],
      [768, 3],
      [992, 4.3],
      [1200, 6],
      [1500, 6]
    ]},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var data = ref.data;
return [_c('last-lesson-card',{attrs:{"lesson":data}})]}}],null,false,968435259)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }